import React from 'react'
import { Link } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

// components
import AccountButton from 'components/atoms/AccountButton'
import InvalidFormHelper from 'components/atoms/InvalidFormHelper'
import FlexibilityText from 'components/shared/Cart/FlexibilityText'

// containers
import Waiver from 'components/shared/Waiver'

// helpers
import { centsToDollars } from 'lib/helpers/money'
import { invalidCheckoutForm } from 'lib/helpers/checkout/forms'
import { PAYMENT_STEP } from 'lib/helpers/registration/navigation'

const CheckoutForm = props => {
  const {
    account, // via query
    waiverForms, // via redux
    total, // via registration/Confirm
    onClickCheckout, // via withEventHandlers
    mutationLoading, // via withMutation
    formErrors // via withFormResults
  } = props

  const { waivers, registrationStatus } = account

  // a declined payment spends the saved payment details, so send them back to re-enter
  const needsPaymentMethod =
    total > 0 && !registrationStatus?.validPaymentMethod

  const invalid = invalidCheckoutForm({ waiverForms })
  const disabled = invalid || mutationLoading

  return (
    <>
      {waivers.length && (
        <Box my={4}>
          {waivers.map(waiver => (
            <Waiver
              key={waiver.id}
              waiver={waiver}
              waiverForms={waiverForms}
              formErrors={formErrors}
            />
          ))}
        </Box>
      )}

      <Container maxWidth='md'>
        <FlexibilityText />
      </Container>

      {needsPaymentMethod ? (
        <Box my={4}>
          <InvalidFormHelper
            invalid
            helpText={registrationStatus.paymentMethodHelpText}
          />
          <AccountButton
            variant='contained'
            color='secondary'
            component={Link}
            to={PAYMENT_STEP.path}
            fullWidth
          >
            Enter a New Payment Method
          </AccountButton>
        </Box>
      ) : (
        <Box my={4}>
          <InvalidFormHelper
            invalid={invalid}
            helpText={'Please agree to the terms above to check out.'}
          />
          <AccountButton
            variant='contained'
            color='secondary'
            disabled={disabled}
            onClick={onClickCheckout}
            fullWidth
          >
            {mutationLoading
              ? 'Submitting…'
              : `Checkout for ${centsToDollars(total)}`}
          </AccountButton>
        </Box>
      )}
    </>
  )
}

export default CheckoutForm
